import { AvailabilityEnum, CategoryEnum } from "../types/product";
export const CATEGORY_TO_NAME = {
    [CategoryEnum.All]: "Wszystkie",
    [CategoryEnum.Ammunition]: "Amunicja",
    [CategoryEnum.ShortWeapon]: "Broń krótka",
    [CategoryEnum.LongWeapon]: "Broń długa",
    [CategoryEnum.Shotgun]: "Strzelby",
    [CategoryEnum.SpecialOffers]: "Oferty specjalne",
    [CategoryEnum.BlackPowder]: "Czarnoprochowa",
};
export const AVAILABILITY_TO_NAME = {
    [AvailabilityEnum.Yes]: "Dostępny",
    [AvailabilityEnum.No]: "Niedostępny",
    [AvailabilityEnum.Unknown]: "Brak danych",
};
export const BACKEND_UNKNOWN_DATA = "Nieznany";
